import React, { useEffect, useState } from "react";
import AllButton from "../components/button/AllButton";
import DateCard from "../components/card/DateCard";
import HorizontalCard from "../components/card/HorizontalCard";
import HeroCard from "../components/card/HeroCard";
import NewsCard from "../components/card/NewsCard";
import FAQ from "../components/mainpage/FAQ";
import ImageCircle from "../components/mainpage/ImageCircle";
import SwiperContent from "../components/mainpage/SwiperContent";
import { HashLink as Link } from "react-router-hash-link";
import ServiceService from "../services/service";
import NewsService from "../services/news";
import FaqService from "../services/faq";
import SliderService from "../services/slider";
import ActivitiesService from "../services/activities";
import ArticleService from "../services/article";
import { useHistory } from "react-router-dom";
import { useParams } from "react-router-dom";

const MAINPAGE_SERVICE_LIMIT = 8;

export default function Mainpage(props) {
  let [serviceData, setServiceData] = useState([]);
  let [newsData, setNewsData] = useState([]);
  let [faqData, setFaqData] = useState([]);
  let [sliderData, setSliderData] = useState(null);
  let [activitiesData, setActivitiesData] = useState([]);
  let [articleData, setArticleData] = useState([]);

  let { lang } = useParams();

  const history = useHistory();

  //return lang function
  useEffect(() => {
    if (lang !== "th" && lang !== "en") {
      window.open(`/th`, "_self");
    }
  });

  useEffect(() => {
    window.scrollTo(0, 0);
    getServiceData();
    getNewsData();
    getFaqData();
    getSliderData();
    getActivitiesData();
    getArticleData();
  }, []);

  const getArticleData = async () => {
    try {
      let res = await ArticleService.getMainpageArticle();
      setArticleData(res);
    } catch {
      console.error();
    }
  };

  const getServiceData = async () => {
    try {
      let res = await ServiceService.getService();
      setServiceData(res);
    } catch {
      console.error();
    }
  };

  const getNewsData = async () => {
    try {
      let [res] = await NewsService.getMainpageNews({
        page: 1,
        pageSize: 3,
      });
      setNewsData(res);
    } catch {
      console.error();
    }
  };

  const getFaqData = async () => {
    try {
      let res = await FaqService.getFaq();
      setFaqData(res);
    } catch {
      console.error();
    }
  };

  const getSliderData = async () => {
    try {
      let res = await SliderService.getImage();
      setSliderData(res);
    } catch {
      console.error();
    }
  };

  const getActivitiesData = async () => {
    try {
      let res = await ActivitiesService.getMainpageActivities();
      setActivitiesData(res);
    } catch {
      console.error();
    }
  };

  return (
    <div id="mainpage" className="pb-[36px] pt-[135px] lg:pt-[0px]">
      {/* Swiper Content */}
      {sliderData ? (
        <SwiperContent data={sliderData} />
      ) : (
        <div className="h-[480px] bg-lightGray" />
      )}
      <div className="section">
        <div className="page-container">
          <div>
            {/* บริการของเรา */}
            {/* หน้าหลักโชว์ไม่เกิน 8 บริการ (4 ช่อง x 2 แถว) ที่เหลือดูได้จากปุ่ม "ทั้งหมด" */}
            <div className="mt-[60px]">
              <div className="relative flex justify-center items-center">
                <h1 className="text-heading font-bold text-center text-brand">
                  {lang === "th" ? "บริการของเรา" : "Service"}
                </h1>
                {serviceData && serviceData.length > MAINPAGE_SERVICE_LIMIT && (
                  <Link
                    className="hidden sm:flex absolute right-0"
                    to={`/${lang}/service`}
                  >
                    <AllButton lang={lang} />
                  </Link>
                )}
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-[20px] mt-[40px]">
                {serviceData &&
                  serviceData.slice(0, MAINPAGE_SERVICE_LIMIT).map((item, i) => (
                    <div
                      key={i}
                      onClick={() => {
                        if (item.link.href && item.link.href !== "-")
                          history.push(`/${lang}/service${item.link.href}`);
                      }}
                    >
                      <ImageCircle item={item} lang={lang} />
                    </div>
                  ))}
              </div>
              {serviceData && serviceData.length > MAINPAGE_SERVICE_LIMIT && (
                <Link className="flex sm:hidden justify-end mt-[20px]" to={`/${lang}/service`}>
                  <AllButton lang={lang} />
                </Link>
              )}
            </div>



            {/* ข่าวสารล่าสุด และ กิจกรรม */}
            <div
              id="mainpage-activity"
              className="mt-[80px] grid grid-cols-1 lg:grid-cols-[1.72fr_1fr] gap-[32px]"
            >
              <div className="items-start min-w-0">
                <div className="flex justify-between">
                  <h1 className="text-heading font-bold text-slateGray text-left after:block after:w-[64px] after:h-[3px] after:bg-brand after:mt-[6px]">
                    {lang === "th" ? "ข่าวสารล่าสุด" : "Lastest News"}
                  </h1>
                  <Link
                    className="flex justify-end"
                    to={`/${lang}/newsAndActivity/news`}
                  >
                    <AllButton lang={lang} />
                  </Link>
                </div>
                <div className="mt-[22px]">
                  {newsData && newsData[0] && (
                    <HeroCard
                      data={newsData[0]}
                      page="newsAndActivity/news"
                      lang={lang}
                    />
                  )}
                </div>

                <div
                  id="mainpage-activity-section"
                  className="flex flex-col gap-[30px] mt-[30px]"
                >
                  {newsData &&
                    newsData
                      .slice(1, 3)
                      .map((item, i) => (
                        <HorizontalCard
                          data={item}
                          key={i}
                          page="newsAndActivity/news"
                          lang={lang}
                        />
                      ))}
                </div>
              </div>
              <div className="items-start min-w-0">
                <div className="flex justify-between items-center mb-[22px]">
                  <h1 className="text-heading font-bold text-slateGray text-left after:block after:w-[64px] after:h-[3px] after:bg-brand after:mt-[6px]">
                    {lang === "th" ? "กิจกรรม" : "Activity"}
                  </h1>
                  <Link
                    className="flex justify-end"
                    to={`/${lang}/newsAndActivity/activity`}
                  >
                    <AllButton lang={lang} />
                  </Link>
                </div>
                <div className="flex flex-col gap-[20px]">
                  {activitiesData &&
                    activitiesData.map((item, i) => (
                      <DateCard
                        key={i}
                        data={item}
                        hasBg={item && item.image[0] ? true : false}
                        page="newsAndActivity/activity"
                        lang={lang}
                      />
                    ))}
                </div>
              </div>
            </div>

            {/* FAQ และ Health Update */}
            <div
              id="mainpage-faq"
              className="mt-[57px] grid grid-cols-1 lg:grid-cols-[609fr_551fr] gap-[40px]"
            >
              <div className="min-w-0 flex flex-col">
                <div className="mb-[20px]">
                  <h1 className="text-heading font-bold text-slateGray text-left after:block after:w-[64px] after:h-[3px] after:bg-brand after:mt-[6px]">
                    FAQ
                  </h1>
                </div>
                {/* จอใหญ่: กล่อง FAQ ลอย (absolute) ไม่ดันความสูงแถว
                    แถวจึงสูงตามฝั่ง Health UPDATE แล้วกล่องยืดเต็มพอดี */}
                <div className="flex-1 relative lg:min-h-[260px]">
                  <div className="lg:absolute lg:inset-0">
                    <FAQ data={faqData} lang={lang} />
                  </div>
                </div>
              </div>
              <div className="min-w-0">
                <div className="mb-[20px] flex justify-between items-center">
                  <div>
                    <h1 className="text-heading font-bold text-slateGray text-left after:block after:w-[64px] after:h-[3px] after:bg-brand after:mt-[6px]">
                      <span className="font-bold">Health</span> UPDATE
                    </h1>
                  </div>
                  <div
                    className="flex justify-end cursor-pointer"
                    onClick={() => {
                      history.push(`/${lang}/article`);
                    }}
                  >
                    <AllButton lang={lang} />
                  </div>
                </div>
                <div className="mt-[20px] grid grid-cols-1 md:grid-cols-2 gap-[30px]">
                  {articleData &&
                    articleData.map((item, i) => (
                      <NewsCard
                        key={i}
                        data={item}
                        lineClamp={2}
                        hideIcon={true}
                        lang={lang}
                        page={"article"}
                      />
                    ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
